import { AxiosService } from './axios.service'

export class LiveloService {
	static baseURL = 'livelo'

	static searchParamethers() {
		return AxiosService.get(`${this.baseURL}/buscar-parametros`).then(
			({ data }) => data.data
		)
	}

	/**
	 * Send muviflex number to transfer livelo points
	 * @param {number} muviflexPoints
	 */
	static transferPoints(muviflexPoints) {
		return AxiosService.post(`${this.baseURL}/transferir-pontos`, {
			muviflexPoints
		})
			.then(({ data }) => data)
			.catch(({ err }) => err)
	}
}
